module.exports = __webpack_public_path__ + "static/img/mo2.de262b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/mo2.png
// module id = NkeB
// module chunks = 7